(() => {
  const root = document.documentElement;
  const mouse = matchMedia('(hover: hover) and (pointer: fine)');
  const base = new URL('./', document.currentScript.src);
  let timer;
  let ready = false;
  const state = (value) => {
    root.dataset.goldenState = value;
    document.querySelectorAll('[data-golden-status]').forEach(label => {
      label.textContent = value === 'sleep' ? 'Se ha quedado dormidito.' : '¡Listo para acompañarte!';
    });
  };
  const wake = (event) => {
    if (!ready || !mouse.matches || document.hidden || (event?.pointerType && event.pointerType !== 'mouse')) return;
    clearTimeout(timer);
    if (root.dataset.goldenState !== 'awake') state('awake');
    timer = setTimeout(() => state('sleep'), 2500);
  };
  const sync = () => {
    clearTimeout(timer);
    root.classList.toggle('golden-cursor-ready', ready && mouse.matches);
    if (ready && mouse.matches) wake();
    else delete root.dataset.goldenState;
  };
  const load = (filename) => new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = resolve;
    img.onerror = reject;
    img.src = new URL(filename, base).href;
  });
  Promise.all(['golden-awake-cursor.png?v=1', 'golden-sleep-cursor.png?v=1'].map(load))
    .then(() => { ready = true; sync(); })
    .catch(() => { /* Keep the normal cursor if an asset cannot load. */ });
  document.addEventListener('pointermove', wake, { passive: true });
  document.addEventListener('pointerdown', wake, { passive: true });
  document.addEventListener('wheel', wake, { passive: true });
  document.addEventListener('visibilitychange', () => {
    clearTimeout(timer);
    if (!document.hidden) wake();
  });
  mouse.addEventListener('change', sync);
})();
